/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, RequestResult } from '#client'
import type { ListUsersOptions, ListUsersResponses } from '../models/ListUsers'
import { client } from '#client'

/**
 * @description The latest snapshot of each requested id that has one: unknown ids are absent and the order is not promised.
 * @summary The profile snapshots of some users
 * {@link /api/users}
 */
export function listUsers<ThrowOnError extends boolean = false>(options: Options<ListUsersOptions, ThrowOnError>): Promise<RequestResult<ListUsersResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return request({ method: 'GET', url: '/api/users', security: [{ type: 'http', scheme: 'bearer' }], styles: { query: { ids: { style: 'form', explode: true } } }, ...config, throwOnError: config.throwOnError ?? false }) as Promise<RequestResult<ListUsersResponses, ThrowOnError>>
}
